import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useStyles } from './styles';
import { throttle } from 'lodash';

const InputSearch = ({ onChange, placeholder, value }) => {
  const [defaultValue, setDefaultValue] = useState(value ? value : '');
  const classes = useStyles();
  const { inputContainer, searchInput, searchIcon } = classes;
  const inputChangeEvent = throttle(e => {
    onChange?.(e?.target?.value);
    setDefaultValue(e?.target?.value);
  }, 300);

  return (
    <div className={inputContainer}>
      <input
        onChange={inputChangeEvent}
        placeholder={placeholder}
        className={searchInput}
        value={defaultValue}
        data-test-id="input_search"
      />
      <SearchOutlined className={searchIcon} />
    </div>
  );
};

InputSearch.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default InputSearch;
